export default __webpack_public_path__ + "static/decoratorTrust-96d19411d3eafe51de8020b9842f18d6.png";